<template>
    <MainContent title="Crear remitente">
        <template v-slot:header>
            <h3 class="card-title mb-3">Crear remitente</h3>
        </template>
        <template v-slot:content>
            <FormRemitente 
                :remitente="remitente" 
                :loading.sync="loading" 
                @terminado="crearRemitente" 
            />
        </template>
    </MainContent>    
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import FormRemitente from '@/components/backend/campana-emails/remitentes/FormRemitente';

    export default {
        data() {
            return {
                remitente: {},
                loading: false
            }
        },
        methods: {
            async crearRemitente(data)
            {
                try
                {
                    this.loading = true;

                    await apiService.createRemitente(data);
                    this.$toast.success("Remitente creado correctamente");
                    this.$router.push({ name: 'back.emails.remitentes.index' });
                    
                }
                catch(error)
                {
                    if (error.response && 
                        error.response.data.errors.email) {
                        this.$toast.error(error.response.data.errors.email[0]);
                    } else {
                        this.$toast.error("Error al crear el remitente: " + error.message);
                    }
                }
                finally
                {
                    this.loading = false;
                }
            }
        },
        components: {
            MainContent, FormRemitente
        }
    }
</script>